import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';

import { DoubleColumnLayout } from '~/src/components/DoubleColumnLayout';
import { StageTitle } from '~/src/features/full-buy/StageTitle';

import * as ST from '../styled';

import * as S from './styled';

const TariffInfoPageSkeleton = ({ title }: { title: string }): JSX.Element => {
    return (
        <SkeletonTheme borderRadius={24} inline={false}>
            <ST.FullBuy>
                <DoubleColumnLayout>
                    <ST.LeftSide>
                        <ST.StageWrap>
                            <StageTitle
                                stageTitle={title}
                                stageNumber={2}
                                currentNumber={1}
                            />
                            <S.Block>
                                <Skeleton height={220} style={{ marginBottom: 8 }}/>
                                <Skeleton height={76} style={{ marginBottom: 8 }}/>
                            </S.Block>
                            <Skeleton height={48} width={236} count={1}/>
                        </ST.StageWrap>
                    </ST.LeftSide>
                    <ST.RightSide>
                        <Skeleton height={310}/>
                    </ST.RightSide>
                </DoubleColumnLayout>
            </ST.FullBuy>
        </SkeletonTheme>
    );
};

export default TariffInfoPageSkeleton;
